import React from "react";

export default function TermsPage() {
  const lastUpdated = "2026-06-18";
  const company = "Saham Vista";
  const appName = "Saham Vista";
  const contactEmail = "hai@sahamvista.com";

  const sections = [
    { id: "intro", title: "Pendahuluan" },
    { id: "important-notice", title: "Pernyataan Penting" },
    { id: "service", title: "Deskripsi Layanan" },
    { id: "investment-risk", title: "Risiko Investasi" },
    { id: "not-advice", title: "Bukan Nasihat Investasi" },
    { id: "ai-disclaimer", title: "Penafian AI & Sinyal" },
    { id: "data-disclaimer", title: "Data Pasar & Data Pihak Ketiga" },
    { id: "account", title: "Akun & Kelayakan" },
    { id: "payments", title: "Paket Premium, Aktivasi & Pembayaran" },
    { id: "telegram", title: "Notifikasi Telegram" },
    { id: "acceptable-use", title: "Penggunaan yang Diperbolehkan" },
    { id: "prohibited-use", title: "Penggunaan yang Dilarang" },
    { id: "content-ip", title: "Konten & Hak Kekayaan Intelektual" },
    { id: "third-party", title: "Layanan Pihak Ketiga" },
    { id: "availability", title: "Ketersediaan & Perubahan Layanan" },
    { id: "liability", title: "Batasan Tanggung Jawab" },
    { id: "indemnity", title: "Ganti Rugi" },
    { id: "termination", title: "Pengakhiran & Penangguhan Akses" },
    { id: "law", title: "Hukum yang Berlaku" },
    { id: "dispute", title: "Penyelesaian Sengketa" },
    { id: "changes", title: "Perubahan Syarat" },
    { id: "contact", title: "Kontak" },
  ];

  return (
    <main className="min-h-screen bg-[#0b0c10] text-gray-200">
      {/* Header */}
      <header className="border-b border-white/10 bg-gradient-to-b from-white/5 to-transparent">
        <div className="mx-auto max-w-5xl px-4 py-10">
          <h1 className="text-3xl font-bold tracking-tight text-purple-300">
            Syarat Layanan
          </h1>
          <p className="mt-2 text-sm text-gray-400">
            {appName} — Terakhir diperbarui:{" "}
            <time dateTime={lastUpdated}>{lastUpdated}</time>
          </p>
        </div>
      </header>

      {/* Body */}
      <div className="mx-auto max-w-5xl px-4 py-8 lg:grid lg:grid-cols-12 lg:gap-8">
        {/* TOC */}
        <aside className="lg:col-span-4 lg:sticky lg:top-4 lg:self-start">
          <div className="rounded-xl border border-white/10 bg-white/5 p-4">
            <h2 className="mb-3 text-sm font-semibold text-gray-300">
              Daftar Isi
            </h2>

            <nav className="space-y-1">
              {sections.map((s) => (
                <a
                  key={s.id}
                  href={`#${s.id}`}
                  className="block rounded px-2 py-1 text-sm text-gray-400 hover:bg-white/10 hover:text-white"
                >
                  {s.title}
                </a>
              ))}
            </nav>

            <div className="mt-4 flex flex-wrap items-center gap-2">
              <button
                type="button"
                onClick={() => window.print()}
                className="inline-flex items-center rounded-lg border border-white/10 bg-white/10 px-3 py-1.5 text-xs text-gray-100 hover:bg-white/20"
              >
                Cetak / Simpan PDF
              </button>

              <a
                href="/"
                className="text-xs text-purple-300 hover:underline"
                aria-label="Kembali ke aplikasi"
              >
                Kembali ke aplikasi
              </a>
            </div>
          </div>
        </aside>

        {/* Content */}
        <article className="mt-8 space-y-10 lg:col-span-8 lg:mt-0">
          <Section id="intro" title="Pendahuluan">
            <p>
              Syarat Layanan (“Syarat”) ini mengatur penggunaan Anda atas{" "}
              {appName}, yang dioperasikan oleh {company}. Dengan mengakses,
              membuat akun, menggunakan fitur gratis, menggunakan fitur premium,
              menerima notifikasi, atau menggunakan informasi yang tersedia di{" "}
              {appName}, Anda menyatakan telah membaca, memahami, dan menyetujui
              Syarat ini.
            </p>

            <p>
              Apabila Anda tidak menyetujui Syarat ini, Anda tidak diperkenankan
              menggunakan layanan {appName}.
            </p>
          </Section>

          <Section id="important-notice" title="Pernyataan Penting">
            <div className="rounded-xl border border-yellow-400/30 bg-yellow-400/10 p-4 text-yellow-100">
              <p className="m-0">
                <strong>Penting:</strong> {appName} bukan penasihat investasi,
                broker, manajer investasi, perantara perdagangan efek, atau
                lembaga jasa keuangan. Seluruh sinyal, insight, watchlist, skor,
                ranking, analisis AI, analisis broker, dan informasi lain hanya
                disediakan untuk tujuan informasi, edukasi, dan riset pribadi.
                Keputusan investasi sepenuhnya menjadi tanggung jawab pengguna.
                Investasi saham mengandung risiko kerugian.
              </p>
            </div>
          </Section>

          <Section id="service" title="Deskripsi Layanan">
            <p>
              {appName} adalah platform informasi dan analisis saham berbasis web
              yang dapat menyediakan fitur seperti watchlist, sinyal indikatif,
              insight berbasis kecerdasan buatan, analisis broker summary,
              analisis akumulasi/distribusi broker, analisis laporan keuangan,
              ranking saham, dan notifikasi melalui kanal komunikasi tertentu.
            </p>

            <p>
              Fitur, cakupan data, metodologi analisis, tampilan, algoritma,
              indikator, dan ketersediaan layanan dapat berubah dari waktu ke
              waktu sesuai pengembangan produk, kebutuhan teknis, perubahan data,
              atau pertimbangan operasional {company}.
            </p>

            <p>
              {appName} tidak menyediakan fasilitas transaksi saham, tidak
              menerima dana nasabah, tidak mengeksekusi order jual/beli, dan tidak
              menjamin ketersediaan akses ke pasar modal.
            </p>
          </Section>

          <Section id="investment-risk" title="Risiko Investasi">
            <p>
              Investasi dan/atau perdagangan saham memiliki risiko kerugian,
              termasuk kemungkinan kehilangan sebagian atau seluruh modal. Harga
              saham dapat bergerak naik maupun turun karena berbagai faktor,
              termasuk kondisi pasar, kinerja emiten, sentimen investor,
              likuiditas, aksi korporasi, kondisi ekonomi, perubahan regulasi,
              dan faktor lain di luar kendali {company}.
            </p>

            <p>
              Kinerja historis, hasil backtest, pola broker, akurasi sinyal
              sebelumnya, target profit, cut loss, ranking, atau hasil analisis
              masa lalu tidak menjamin hasil di masa depan. Pengguna wajib
              memahami bahwa setiap keputusan investasi mengandung risiko dan
              dapat menghasilkan kerugian.
            </p>
          </Section>

          <Section id="not-advice" title="Bukan Nasihat Investasi">
            <p>
              Seluruh informasi, sinyal, insight, skor, ranking, watchlist,
              analisis broker, analisis laporan keuangan, ringkasan AI, dan
              konten lain yang tersedia di {appName} hanya disediakan untuk tujuan
              informasi, edukasi, dan riset pribadi.
            </p>

            <p>
              Konten tersebut bukan merupakan nasihat keuangan, nasihat investasi,
              rekomendasi personal, ajakan membeli atau menjual efek, penawaran
              produk investasi, riset resmi sekuritas, atau pengganti konsultasi
              dengan penasihat investasi berizin.
            </p>

            <p>
              Pengguna bertanggung jawab untuk melakukan analisis mandiri,
              mempertimbangkan profil risiko pribadi, tujuan investasi, kondisi
              keuangan, dan/atau berkonsultasi dengan profesional berizin sebelum
              mengambil keputusan investasi.
            </p>
          </Section>

          <Section id="ai-disclaimer" title="Penafian AI & Sinyal">
            <p>
              Beberapa fitur {appName} dapat menggunakan kecerdasan buatan atau
              pemrosesan otomatis untuk menghasilkan ringkasan, interpretasi,
              insight, sinyal indikatif, atau penjelasan atas data saham. Output
              AI bersifat probabilistik dan dapat mengandung kesalahan,
              ketidaktepatan, bias, keterlambatan, atau interpretasi yang tidak
              lengkap.
            </p>

            <p>
              Sinyal seperti “BUY”, “WATCH”, “HOLD”, ranking saham, skor, atau
              insight lain tidak boleh dianggap sebagai instruksi transaksi atau
              jaminan keuntungan. Pengguna tidak boleh menjadikan output AI atau
              sinyal dari {appName} sebagai satu-satunya dasar keputusan
              investasi.
            </p>

            <p>
              {company} tidak menjamin bahwa setiap sinyal, insight, ranking,
              target, atau analisis akan menghasilkan keuntungan, menghindarkan
              kerugian, atau sesuai dengan kondisi pasar aktual.
            </p>
          </Section>

          <Section id="data-disclaimer" title="Data Pasar & Data Pihak Ketiga">
            <p>
              Data yang ditampilkan di {appName} dapat berasal dari Bursa Efek
              Indonesia, laporan keuangan emiten, sumber publik, penyedia data
              pihak ketiga, hasil pengolahan internal, atau sumber lain yang
              dianggap relevan.
            </p>

            <p>
              {company} berupaya menjaga agar data yang ditampilkan akurat dan
              relevan, namun tidak menjamin bahwa data selalu akurat, lengkap,
              real-time, bebas kesalahan, bebas keterlambatan, atau tersedia
              setiap saat. Perbedaan data dapat terjadi karena keterlambatan
              pembaruan, koreksi data, gangguan sistem, perubahan sumber data,
              keterbatasan akses, atau kesalahan pemrosesan.
            </p>

            <p>
              Pengguna memahami bahwa informasi pasar dapat berubah dengan cepat.
              Pengguna wajib melakukan pengecekan ulang ke sumber resmi atau
              platform perdagangan yang digunakan sebelum mengambil keputusan
              investasi.
            </p>
          </Section>

          <Section id="account" title="Akun & Kelayakan">
            <ul className="list-disc space-y-2 pl-5">
              <li>
                Anda harus menggunakan akun Google milik Anda sendiri untuk
                mengakses layanan.
              </li>
              <li>
                Kami dapat menerima data dari Google berupa{" "}
                <strong>nama</strong> dan <strong>alamat email</strong> untuk
                keperluan autentikasi dan pengelolaan akun.
              </li>
              <li>
                Anda bertanggung jawab atas keamanan akses ke perangkat, akun
                Google, dan akun {appName} Anda.
              </li>
              <li>
                Anda tidak boleh membagikan akses akun premium, kode aktivasi,
                atau kredensial kepada pihak lain.
              </li>
              <li>
                Anda wajib menggunakan layanan sesuai hukum yang berlaku dan tidak
                menggunakan layanan untuk tujuan yang melanggar hukum.
              </li>
            </ul>
          </Section>

          <Section id="payments" title="Paket Premium, Aktivasi & Pembayaran">
            <p>
              {appName} dapat menyediakan fitur gratis, masa trial, paket premium,
              kode aktivasi, atau model pembayaran lainnya. Fitur yang tersedia
              untuk setiap paket dapat berbeda dan dapat berubah dari waktu ke
              waktu.
            </p>

            <p>
              Kode aktivasi hanya dapat digunakan sesuai ketentuan yang ditetapkan,
              termasuk namun tidak terbatas pada email, durasi paket, masa berlaku,
              dan batas penggunaan. Kode aktivasi tidak boleh dijual kembali,
              dipindahtangankan, disalahgunakan, atau digunakan untuk akun lain
              tanpa persetujuan tertulis dari {company}.
            </p>

            <p>
              Kecuali diwajibkan oleh hukum yang berlaku atau dinyatakan lain
              secara tertulis, pembayaran paket premium dan/atau kode aktivasi
              bersifat final dan tidak dapat dikembalikan. Permintaan pengembalian
              dana dapat ditinjau berdasarkan kasus tertentu, namun {company} tidak
              berkewajiban menyetujui pengembalian dana atas alasan kerugian
              investasi, perubahan keputusan trading, ketidakcocokan hasil sinyal,
              atau perubahan preferensi pengguna.
            </p>
          </Section>

          <Section id="telegram" title="Notifikasi Telegram">
            <p>
              {appName} dapat menyediakan notifikasi melalui Telegram atau kanal
              komunikasi lain sebagai fitur tambahan. Notifikasi dapat berisi
              insight watchlist, informasi saham, status sistem, atau informasi
              lain yang dianggap relevan.
            </p>

            <p>
              {company} tidak menjamin bahwa notifikasi akan selalu terkirim,
              diterima tepat waktu, lengkap, akurat, atau bebas gangguan.
              Keterlambatan, kegagalan pengiriman, gangguan Telegram, gangguan
              jaringan, atau kesalahan sistem tidak dapat dijadikan dasar klaim
              kerugian investasi.
            </p>
          </Section>

          <Section id="acceptable-use" title="Penggunaan yang Diperbolehkan">
            <ul className="list-disc space-y-2 pl-5">
              <li>
                Menggunakan layanan untuk riset pribadi, edukasi, dan analisis
                mandiri atas saham.
              </li>
              <li>
                Membuat watchlist, membaca insight, dan memanfaatkan fitur analisis
                sesuai batas penggunaan yang wajar.
              </li>
              <li>
                Menggunakan data dan konten {appName} hanya untuk kepentingan
                pribadi dan non-komersial, kecuali telah memperoleh persetujuan
                tertulis dari {company}.
              </li>
              <li>
                Memberikan masukan, laporan bug, atau saran pengembangan secara
                bertanggung jawab.
              </li>
            </ul>
          </Section>

          <Section id="prohibited-use" title="Penggunaan yang Dilarang">
            <ul className="list-disc space-y-2 pl-5">
              <li>
                Menggunakan layanan untuk melanggar hukum, menipu, memanipulasi
                pasar, menyebarkan informasi palsu, atau merugikan pihak lain.
              </li>
              <li>
                Melakukan scraping, crawling, pengunduhan massal, data mining,
                reverse engineering, atau otomasi berlebihan tanpa izin tertulis.
              </li>
              <li>
                Menyalin, menjual, menyewakan, mendistribusikan ulang, atau
                menggunakan data dan konten {appName} untuk produk komersial lain
                tanpa izin tertulis.
              </li>
              <li>
                Membagikan akun premium, kode aktivasi, atau akses layanan kepada
                pihak lain.
              </li>
              <li>
                Mengunggah atau mengirimkan malware, script berbahaya, spam,
                konten ilegal, atau konten yang mengganggu sistem.
              </li>
              <li>
                Mencoba mengakses sistem, server, API, database, atau akun pengguna
                lain tanpa izin.
              </li>
              <li>
                Menggunakan layanan dengan cara yang membebani, merusak,
                mengganggu, atau menurunkan kualitas layanan.
              </li>
            </ul>
          </Section>

          <Section id="content-ip" title="Konten & Hak Kekayaan Intelektual">
            <p>
              Hak atas perangkat lunak, source code, desain antarmuka, sistem,
              model analisis, metode pemrosesan, tampilan, logo, merek, dan konten
              milik {appName} tetap menjadi milik {company} dan/atau pemberi
              lisensi kami.
            </p>

            <p>
              Jika Anda mengunggah, mengirim, atau menyimpan konten ke layanan,
              kepemilikan atas konten tersebut tetap berada pada Anda. Anda
              memberikan {company} lisensi terbatas untuk memproses konten tersebut
              semata-mata guna menyediakan, mengamankan, mengembangkan, dan
              meningkatkan layanan.
            </p>

            <p>
              Anda tidak diperkenankan menghapus tanda kepemilikan, menyalin desain
              layanan, mereplikasi fitur secara tidak sah, atau menggunakan elemen
              {appName} untuk membuat layanan serupa yang melanggar hak {company}.
            </p>
          </Section>

          <Section id="third-party" title="Layanan Pihak Ketiga">
            <p>
              Layanan dapat terintegrasi dengan layanan pihak ketiga, termasuk
              namun tidak terbatas pada Google Sign-In, penyedia hosting, penyedia
              AI, Telegram, penyedia data, payment provider, atau layanan
              infrastruktur lainnya.
            </p>

            <p>
              {company} tidak bertanggung jawab atas kebijakan, ketersediaan,
              keamanan, perubahan, gangguan, atau tindakan dari layanan pihak
              ketiga tersebut. Penggunaan layanan pihak ketiga dapat tunduk pada
              syarat dan kebijakan privasi masing-masing pihak ketiga.
            </p>
          </Section>

          <Section id="availability" title="Ketersediaan & Perubahan Layanan">
            <p>
              Kami berupaya menjaga layanan tersedia dan berjalan dengan baik,
              namun tidak menjamin layanan akan selalu tersedia, bebas gangguan,
              bebas kesalahan, aman sepenuhnya, atau berjalan tanpa keterlambatan.
            </p>

            <p>
              {company} dapat menambah, mengubah, membatasi, menangguhkan, atau
              menghentikan fitur tertentu sewaktu-waktu, termasuk fitur gratis,
              fitur premium, sinyal, ranking, notifikasi, sumber data, atau metode
              analisis.
            </p>

            <p>
              Kami juga dapat melakukan pemeliharaan sistem, pembaruan fitur,
              perubahan algoritma, atau penyesuaian layanan tanpa pemberitahuan
              sebelumnya apabila diperlukan untuk menjaga keamanan, stabilitas, atau
              kualitas layanan.
            </p>
          </Section>

          <Section id="liability" title="Batasan Tanggung Jawab">
            <p>
              Sejauh diizinkan oleh hukum yang berlaku, {company} tidak
              bertanggung jawab atas kerugian langsung, tidak langsung, insidental,
              khusus, konsekuensial, kehilangan keuntungan, kehilangan peluang,
              kehilangan data, gangguan bisnis, kerugian investasi, kerugian
              perdagangan saham, floating loss, realized loss, missed opportunity,
              atau kerusakan lain yang timbul dari penggunaan atau ketidakmampuan
              menggunakan layanan.
            </p>

            <p>
              {company} tidak bertanggung jawab atas keputusan investasi yang
              diambil pengguna berdasarkan informasi, sinyal, insight, notifikasi,
              ranking, analisis AI, atau data yang tersedia di {appName}.
            </p>

            <p>
              Apabila berdasarkan hukum yang berlaku {company} tetap dianggap
              memiliki tanggung jawab, maka tanggung jawab total {company} dibatasi
              pada jumlah yang benar-benar Anda bayarkan kepada {company} untuk
              layanan dalam 3 bulan terakhir sebelum klaim timbul.
            </p>
          </Section>

          <Section id="indemnity" title="Ganti Rugi">
            <p>
              Anda setuju untuk membebaskan, mengganti rugi, dan melindungi{" "}
              {company}, pengelola, afiliasi, mitra, pemberi lisensi, dan penyedia
              layanan kami dari klaim, kerugian, kewajiban, biaya, atau tuntutan
              yang timbul akibat pelanggaran Anda terhadap Syarat ini, pelanggaran
              hukum, penyalahgunaan layanan, pelanggaran hak pihak ketiga, atau
              keputusan investasi yang Anda ambil.
            </p>
          </Section>

          <Section id="termination" title="Pengakhiran & Penangguhan Akses">
            <p>
              Anda dapat berhenti menggunakan layanan kapan saja. Anda juga dapat
              meminta penghapusan akun melalui{" "}
              <a className="underline" href={`mailto:${contactEmail}`}>
                {contactEmail}
              </a>
              .
            </p>

            <p>
              {company} berhak menangguhkan, membatasi, atau menghentikan akses
              pengguna apabila terdapat indikasi pelanggaran Syarat ini,
              penyalahgunaan akun, penggunaan tidak wajar, percobaan scraping,
              pelanggaran hukum, gangguan sistem, risiko keamanan, atau tindakan
              yang dapat merugikan {company}, layanan, atau pengguna lain.
            </p>

            <p>
              Setelah akses dihentikan, beberapa ketentuan dalam Syarat ini tetap
              berlaku, termasuk ketentuan mengenai hak kekayaan intelektual,
              penafian, batasan tanggung jawab, ganti rugi, hukum yang berlaku,
              dan penyelesaian sengketa.
            </p>
          </Section>

          <Section id="law" title="Hukum yang Berlaku">
            <p>
              Syarat ini diatur oleh dan ditafsirkan berdasarkan hukum Republik
              Indonesia, tanpa memperhatikan pertentangan kaidah hukumnya.
            </p>
          </Section>

          <Section id="dispute" title="Penyelesaian Sengketa">
            <p>
              Setiap perselisihan yang timbul dari atau berkaitan dengan Syarat
              ini atau penggunaan layanan akan diselesaikan terlebih dahulu secara
              musyawarah untuk mufakat.
            </p>

            <p>
              Apabila penyelesaian secara musyawarah tidak tercapai, para pihak
              sepakat untuk menyelesaikan sengketa melalui forum yang berwenang di
              Indonesia, kecuali disepakati lain secara tertulis oleh para pihak.
            </p>
          </Section>

          <Section id="changes" title="Perubahan Syarat">
            <p>
              {company} dapat memperbarui Syarat ini dari waktu ke waktu. Perubahan
              material dapat diberitahukan melalui aplikasi, halaman web, email,
              atau kanal komunikasi lain yang dianggap sesuai.
            </p>

            <p>
              Tanggal “Terakhir diperbarui” pada bagian atas halaman akan
              disesuaikan. Dengan tetap menggunakan layanan setelah perubahan
              berlaku, Anda dianggap telah menyetujui Syarat yang telah diperbarui.
            </p>
          </Section>

          <Section id="contact" title="Kontak">
            <p>
              Pertanyaan mengenai Syarat Layanan dapat dikirimkan ke:{" "}
              <a className="underline" href={`mailto:${contactEmail}`}>
                {contactEmail}
              </a>
              .
            </p>
          </Section>

          <div className="border-t border-white/10 pt-6 text-sm text-gray-400">
            © {new Date().getFullYear()} {company}. Semua hak dilindungi.
          </div>
        </article>
      </div>

      {/* Small top offset so anchor links don't hide behind header */}
      <style>{`
        :target { scroll-margin-top: 96px; }

        @media print {
          aside {
            display: none;
          }

          header {
            border: none;
            background: transparent;
          }

          main {
            background: #fff !important;
            color: #000 !important;
          }

          a {
            color: #000 !important;
            text-decoration: underline;
          }
        }
      `}</style>
    </main>
  );
}

function Section({ id, title, children }) {
  return (
    <section id={id} className="scroll-mt-24">
      <h2 className="mb-3 text-xl font-semibold text-white">{title}</h2>
      <div className="prose prose-invert max-w-none prose-p:leading-relaxed prose-li:leading-relaxed">
        {children}
      </div>
    </section>
  );
}
